export default __webpack_public_path__ + "static/bg-white-bb881c7658bd5ceacbfe73d9d6b3aa2c.jpg";